function getDefaultSdkConfiguration() {
    return {
        disableConsoleLogOverride: false,
    };
}

export { getDefaultSdkConfiguration as default };
